
















import { defineComponent } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useSystemSettings from "@/hooks/useSystemSettings";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import CardListView from "./components/CardListView";

export default defineComponent({
  name: "PagePaymentCards",
  components: { CardListView, BasePage, BaseConfirm, BaseButton, PageTitle },
  setup() {
    const { creditCardAllowed } = useSystemSettings();
    const { authUserStrict } = useAuthUser();
    return { creditCardAllowed, authUserStrict };
  },
  data() {
    return {
      cards: [] as CreditCardAssignment[],
      loading: true,
      showConfirm: false,
      removerLoading: false,
    };
  },
  methods: {
    async removeCard() {
      if (this.cards.length === 0) return;
      try {
        this.removerLoading = true;
        let resp = await providers.CreditCardAssignmentsProvider.delete({ id: this.cards[0].id });
        if (resp) this.cards = [];
        this.showConfirm = false;
      } finally {
        this.removerLoading = false;
      }
    },
  },
  created() {
    if (!this.creditCardAllowed) {
      this.$router.push("/");
      return;
    }
    providers.CreditCardAssignmentsProvider.findAll({ userId: this.authUserStrict.id })
      .then(r => (this.cards = r))
      .finally(() => (this.loading = false));
  },
});
